import { render } from "./index.vue?vue&type=template&id=74a8e9a9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=74a8e9a9&lang=css"
import "./index.vue?vue&type=style&index=1&id=74a8e9a9&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a8e9a9"]])

export default __exports__